import { render } from "./orderdeliveryhandover.vue?vue&type=template&id=662f8dc8"
import script from "./orderdeliveryhandover.vue?vue&type=script&lang=js"
export * from "./orderdeliveryhandover.vue?vue&type=script&lang=js"

import "./orderdeliveryhandover.vue?vue&type=style&index=0&id=662f8dc8&lang=scss"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__